import logo from '../assets/sproutLogo.svg'
import nav from '../assets/nav.png'
import { Link } from "react-router-dom";


const Nav = () => {
    return (
        <div className="wrapper">
        <nav className="nav">
            <div className="logoTitle">
                <div className="logo">
                <Link 
                to="/"><img src={logo} alt="Sprout logo" /></Link>
                
                
                </div>
                <h5>Sprout</h5>
            </div>
            <div className="navBar">
                <Link 
                to="/results"><img src={nav} alt="hamburger menu" /></Link>
                
            </div>
        </nav>
        </div>
    )
}

export default Nav